import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { generateNameFields } from 'donor-elf-web/models/contact';
import FundsService from 'donor-elf-web/services/funds-service';
import { type TaskGenerator, task } from 'ember-concurrency';

export default class AddContactController extends Controller {
  @service declare contactsCache: any;
  @service declare fundsService: FundsService;
  @service declare router: RouterService;

  nameOrMailingNameManuallyChanged = false;

  @action
  templateDidInsert() {
    this.nameOrMailingNameManuallyChanged = false;
  }

  @action
  generateNameAndMailingName() {
    if (!this.nameOrMailingNameManuallyChanged) {
      let changeset = this.model.changeset;
      let names = generateNameFields({
        firstName: changeset.get('firstName'),
        lastName: changeset.get('lastName'),
        spouseFirstName: changeset.get('spouseFirstName'),
        spouseLastName: changeset.get('spouseLastName'),
      });
      changeset.set('name', names.name);
      changeset.set('mailingName', names.mailingName);
    }
  }

  @action
  handleNameOrMailingNameManuallyChanged() {
    this.nameOrMailingNameManuallyChanged = true;
  }

  @task *save(): TaskGenerator {
    let changeset = this.model.changeset;
    ['name', 'mailingName', 'firstName', 'lastName', 'spouseFirstName'].forEach(
      (nameProperty) => {
        changeset.set(nameProperty, changeset.get(nameProperty)?.trim());
      },
    );
    changeset.set('name', changeset.get('name')?.trim());
    yield changeset.validate();
    if (changeset.get('isValid')) {
      yield changeset.save();
      this.contactsCache.addContact(this.model.record);
      this.router.transitionTo(
        'funds.fund.contacts.contact',
        changeset.get('id'),
      );
    }
  }
}
